export default __webpack_public_path__ + "locales/fi/HotkeysPanel.json?hash=ec6c570df59f59a537acf7f05527ef56";